export const iconFontAwesomeHandsHandsHoldingCircle = (
	<i className="fa-solid fa-hands-holding-circle"></i>
);
